import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { EMPTY, Observable } from 'rxjs';
import { catchError, distinctUntilChanged, first, shareReplay, switchMap, tap } from 'rxjs/operators';
import { Country } from 'src/app/models/country';
import { CountryService } from 'src/app/services/country/country.service';
import { CountryRequestService } from 'src/app/services/country-request/country-request.service';
import { MixpanelService } from 'src/app/services/mixpanel/mixpanel.service';

@Component({
  selector: 'app-employee-calculator',
  templateUrl: './employee-calculator.component.html',
  styleUrls: ['./employee-calculator.component.scss']
})
export class EmployeeCalculatorComponent implements OnInit {
  public country$: Observable<Country>;
  public isUserCountry$: Observable<boolean>;
  public loading_user_country = true;
  private _country: Country;

  constructor(
    private route: ActivatedRoute,
    private countryService: CountryService,
    private countryRequestService: CountryRequestService,
    private router: Router,
    private mixpanelService: MixpanelService
  ) {}

  public requestAddToSubscription() {
    if (!this._country || (this.loading_user_country && !this._country.unsupported)) {
      return;
    }
    this.countryRequestService.requestAddToSubscription(this._country);
  }

  public requestCreateCountry() {
    if (!this._country) {
      return;
    }
    this.countryRequestService.requestCreateCountry(this._country);
  }

  ngOnInit(): void {
    this.country$ = this.route.paramMap.pipe(
      distinctUntilChanged(),
      switchMap((params: ParamMap) =>
        this.countryService.getCountry(params.get('slug'))
      ),
      catchError((_) => {
        this.router.navigate(['404']);
        return EMPTY;
      }),
      tap((c) => {
        this.isUserCountry$ = this.countryService.isUserCountry(c);
        this.isUserCountry$.pipe(first()).subscribe(() => {
          this.loading_user_country = false;
        });
      }),
      tap((c) => (this._country = c)),
      tap((c) =>
        this.mixpanelService.track('Page: Employee Cost Calculator', {
          'GPS Country': c?.name,
        })
      ),
      shareReplay(1)
    );

  }

}
